/**
 * Formatacao de CPF e CNPJ — funcoes PURAS, zero dependencia.
 *
 * ⚠️ Saiu do `FormatFunctions.tsx` porque aquele arquivo importa
 * `@chakra-ui/react` e React: quem so' queria formatar um documento arrastava
 * a arvore de componentes junto, e **nao dava pra testar** (hoje o jest do CRA
 * nao resolve o chakra). O `FormatFunctions` reexporta tudo daqui, entao os
 * ~99 pontos que ja importavam de la' seguem funcionando sem mudanca.
 */

export const formatCPF = (cpf: string | number): string => {
  const cpfStr = cpf.toString().replace(/\D/g, '').padStart(11, '0');
  return cpfStr.replace(/^(\d{3})(\d{3})(\d{3})(\d{2})$/, '$1.$2.$3-$4');
};

// ⚠️ CNPJ ALFANUMERICO (IN RFB 2.229/2024): as 12 primeiras posicoes aceitam
// letra. Aqui a normalizacao NAO pode ser `replace(/\D/g,'')`.
//
// O estrago era visivel na tela, nao so' interno: `12ABC34501DE35` perdia as
// letras e virava `123450135` — 9 caracteres, que o `getDocumentType` lia como
// CPF e o `formatCPF` exibia como **001.234.501-35**. Ou seja, o operador via
// um documento que nao existe, com aparencia de legitimo.
const somenteAlfanumerico = (value: string | number): string =>
  value
    .toString()
    .replace(/[^A-Za-z0-9]/g, '')
    .toUpperCase();

export const formatCNPJ = (cnpj: string | number): string => {
  const cnpjStr = somenteAlfanumerico(cnpj).padStart(14, '0');
  return cnpjStr.replace(
    /^([A-Z0-9]{2})([A-Z0-9]{3})([A-Z0-9]{3})([A-Z0-9]{4})(\d{2})$/,
    '$1.$2.$3/$4-$5',
  );
};

// Retorna o tipo do documento (CPF ou CNPJ)
//
// CPF nunca tem letra; CNPJ pode ter. Entao a presenca de letra ja decide, e o
// desempate por TAMANHO (<= 11) so' vale para o que e' puramente numerico —
// era o criterio de sempre, preservado para nao mudar nada de CPF.
export const getDocumentType = (value: string | number | null | undefined): 'CPF' | 'CNPJ' => {
  if (!value) return 'CNPJ';
  const limpo = somenteAlfanumerico(value);
  if (/[A-Z]/.test(limpo)) return 'CNPJ';
  return limpo.length <= 11 ? 'CPF' : 'CNPJ';
};

// Detecta se é CPF ou CNPJ e formata adequadamente
export const formatCPFOrCNPJ = (value: string | number | null | undefined): string => {
  if (!value) return '';
  const limpo = somenteAlfanumerico(value);
  if (getDocumentType(value) === 'CPF') {
    return formatCPF(limpo);
  }
  return formatCNPJ(limpo);
};
